import StandingsTestingBase from "./StandingsTestingBase";

export default function StandingsTestingTeam() {
    return (
        <StandingsTestingBase
            scopeType="TEAM"
            classKey=""
            heading="Meisterschaftswertung"
            pillLabel="TEAM"
        />
    );
}
